import React, { useEffect, useRef } from 'react';

const RawHtml = ({ html }) => {
  const ref = useRef(null);

  useEffect(() => {
    if (!ref.current || typeof html !== 'string') return;

    const container = ref.current;
    const parent = container.parentNode;

    if (!parent) return;

    // Parse the HTML string into real nodes
    const temp = document.createElement('div');
    temp.innerHTML = html;

    const fragment = document.createDocumentFragment();
    while (temp.firstChild) {
      fragment.appendChild(temp.firstChild);
    }

    // Insert parsed nodes before the placeholder
    parent.insertBefore(fragment, container);

    // Remove the placeholder
    parent.removeChild(container);
  }, [html]);

  return <span ref={ref} style={{ display: 'none' }} aria-hidden="true" />;
};

export default RawHtml;
